import {useEffect, useCallback} from 'react';
import {t} from "i18next";
import {useApi} from "../../api/useApi";

export const useVkAuth = ({clientId, redirectUri, buttonContainerId}) => {
    const {authThroughSocialMedia} = useApi();

    const initVkAuth = useCallback(() => {
        const container = document.getElementById(buttonContainerId);
        if (!container) return;

        container.innerHTML = '';

        if ('VKIDSDK' in window) {
            const VKID = window.VKIDSDK;
            try {
                VKID.Config.init({
                    app: clientId,
                    redirectUrl: redirectUri,
                    source: VKID.ConfigSource.LOWCODE,
                    responseMode: VKID.ConfigResponseMode.Callback,
                    scope: 'email phone'
                });

                const oneTap = new VKID.OneTap();

                oneTap.render({
                    container: container,
                    fastAuthEnabled: false,
                    showAlternativeLogin: true,
                    styles: {
                        borderRadius: 9,
                        width: 32,
                        height: 32
                    }
                })
                    .on(VKID.WidgetEvents.ERROR, console.error(t('common.logIn.vkWidgetError')))
                    .on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, function (payload) {
                        const code = payload.code;
                        const deviceId = payload.device_id;

                        VKID.Auth.exchangeCode(code, deviceId)
                            .then(response => {
                                authThroughSocialMedia('vk', {search: ''}, 'post', {access_token: response.access_token})
                            })
                            .catch(() => console.error(t('common.logIn.vkAuthError')));
                    });

            } catch (err) {
                console.error(t('common.logIn.vkWidgetError'))
            }
        }
    }, [clientId, redirectUri, buttonContainerId]);

    useEffect(() => {
        initVkAuth()
    }, [buttonContainerId]);

    return {initVkAuth};
};